import { Navigation } from "@/components/Navigation"
import { Footer } from "@/components/Footer"
import { ContactSection } from "@/components/ContactSection"
import { PageFAQ } from "@/components/PageFAQ"
import { contactFAQs } from "@/data/faqData"

import { SEO } from "@/components/SEO"

const Contact = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Contact RSA Tech Group | Let's Build Something Extraordinary"
        description="Looking to discuss a project, partnership, or career opportunity? Get in touch with our team."
        image="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&q=80&w=2070"
      />
      <Navigation />
      <div className="pt-24">
        <ContactSection />
      </div>
      <PageFAQ
        faqs={contactFAQs}
        title="Contact & Engagement FAQs"
        subtitle="Common questions about working with RSA Tech Group"
        variant="muted"
      />
      <Footer />
    </div>
  )
}

export default Contact
